import styles from "./ActorCardHorizontal.module.scss";
import SavedIcon from "../../../components/icons/searchIcons/savedIcon";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";

export interface Actor {
  id: number;
  name?: string | null;
  profile_path: string | null;
  popularity: number;
  known_for_department: string | null;
  place_of_birth: string | null;
  in_favorite: boolean;
  movies_count: number;
}

type ActorCardProps = {
  actor: Actor;
  isFav?: boolean;
  favouritesHandler?: (e: any, actor: Actor, isFav: boolean) => void;
  isFavoritePage?: boolean;
};

const getImageSrc = (profilePath: string | null) => {
  if (!profilePath) return "";
  if (profilePath.startsWith("http")) return profilePath;

  return `${process.env.REACT_APP_IMG_BASE_URL}${profilePath}`;
};

const getActorName = (actor: Actor) => {
  return actor.name || "Unknown actor";
};

const ActorCardHorisontal = ({ actor, isFav, favouritesHandler, isFavoritePage }: ActorCardProps) => {
  const navigate = useNavigate();
  const image = getImageSrc(actor.profile_path);
  const actorName = getActorName(actor);
  const actorPlace = actor.place_of_birth || actor.known_for_department || "";
  const inFavourites = isFav ?? actor.in_favorite;

  return (
    <article
      className={styles.cardWrapper} onClick={() => navigate(`${ROUTES.ACTORS}/${actor.id}`)}>
      <div className={styles.imageWrapper}>
        {image ? (
          <img className={styles.image} src={image} alt={actorName} />
        ) : (
          <div className={styles.imagePlaceholder}>{actorName.slice(0, 1)}</div>
        )}
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.infoRow}>
          <div className={styles.infoContent}>
            <h3 className={styles.actorName}>{actorName}</h3>
            {actorPlace && <p className={styles.place}>{actorPlace}</p>}
          </div>
          <button
            className={styles.savedIconWrapper}
            type="button"
            aria-label="toggle actor favorite"
            onClick={(event) => favouritesHandler?.(event, actor, inFavourites)}
          >
            <SavedIcon className={styles.savedIcon} inFavourites={inFavourites} />
          </button>
        </div>
      </div>
    </article>
  );
};

export default ActorCardHorisontal;
